import dynamic from 'next/dynamic'
import ErrorBoundaryWithTranslations from './ErrorBoundaryWithTranslations'
import Hotels, { Props } from './Hotels'

const HotelsWithErrorBoundary = (props: Props) => {
	return (
		<ErrorBoundaryWithTranslations>
			<Hotels {...props} />
		</ErrorBoundaryWithTranslations>
	)
}

export default dynamic(() => Promise.resolve(HotelsWithErrorBoundary), {
	ssr: false,
})
